import {useState, useRef, useEffect, useLayoutEffect} from 'react';
import Draggable from 'react-draggable';

import Helmet from '../components/Helmet/Helmet';
import retinaBgVideo from '../assets/images/RETINABG.png';

import '../styles/retina.css';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase.config';

import { useNavigate } from 'react-router-dom';

const Retina = () => {

    const [positions, setPositions] = useState({});
    const [activeDrags, setActiveDrags] = useState(0);
    const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
    const [zIndices, setZIndices] = useState({});
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const getRandomPosition = (container) => {
        if (!container) {
            return { x: 0, y: 0 };
        }
        
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        
        // Use smaller dimensions for mobile
        const isMobile = window.innerWidth <= 768;
        const draggableWidth = isMobile ? 100 : 240;
        const draggableHeight = isMobile ? 100 : 240;

        // Ensure we don't position outside container bounds
        const maxX = Math.max(0, containerWidth - draggableWidth);
        const maxY = Math.max(0, containerHeight - draggableHeight);

        // Add some padding from edges
        const padding = isMobile ? 10 : 20;
        const x = padding + Math.floor(Math.random() * (maxX - padding * 2));
        const y = padding + Math.floor(Math.random() * (maxY - padding * 2));

        return { x, y };
    }


    useEffect(() => {
       const fetchProducts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "retinaImages"));
                const filteredProducts = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                // const filteredProducts = productsList.filter(item => item.category === 'NFT');
                setData(filteredProducts);
                console.log("Retina+ products: ", filteredProducts);
            } catch (error) {
                console.error("Error fetching products: ", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    useLayoutEffect(() => {
        if (containerRef.current && data.length > 0) {
            const savedPositions = JSON.parse(localStorage.getItem('retinaPositions') || '{}');
            
            const newPositions = {};
            data.forEach(product => {
                if (savedPositions[product.id]) {
                    newPositions[product.id] = savedPositions[product.id];
                } else {
                    newPositions[product.id] = getRandomPosition(containerRef.current);
                }
            });
            
            setPositions(newPositions);
        }
    }, [data]);

    const onStart = (e, productId) => {
        setActiveDrags(prev => prev + 1);
        
        let clientX, clientY;
        if (e.type.includes('touch')) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        } else {
            clientX = e.clientX;
            clientY = e.clientY;
        }
        
        setStartPosition({ x: clientX, y: clientY });
        
        const maxZIndex = Object.values(zIndices).reduce((max, val) => Math.max(max, val), 0);
        const nextZIndex = maxZIndex + 1;
        setZIndices(prev => ({
            ...prev,
            [productId]: nextZIndex
        }));
    };

    const onStop = (e, productId, position) => {
        setActiveDrags(prev => prev - 1);
        
        let clientX, clientY;
        if (e.type.includes('touch')) {
            clientX = e.changedTouches[0].clientX;
            clientY = e.changedTouches[0].clientY;
        } else {
            clientX = e.clientX;
            clientY = e.clientY;
        }
        
        const endPosition = { x: clientX, y: clientY };
        const distance = Math.sqrt(
            Math.pow(endPosition.x - startPosition.x, 2) +
            Math.pow(endPosition.y - startPosition.y, 2)
        );

        if (distance < 5) {
            navigate(`/product-detail/${productId}`);
        } else {
            const newPositions = {
                ...positions,
                [productId]: { x: position.x, y: position.y }
            };
            setPositions(newPositions);
            localStorage.setItem('retinaPositions', JSON.stringify(newPositions));
        }
    };

    const Positions = () => {
        if (containerRef.current && data.length > 0) {
            const newPositions = {};
            data.forEach(product => {
                newPositions[product.id] = getRandomPosition(containerRef.current);
            });
            
            setPositions(newPositions);
            localStorage.setItem('retinaPositions', JSON.stringify(newPositions));
        }
    };

    return (
        <Helmet title={'Retina+'}>
            <section className='retina'>
                <img src={retinaBgVideo} alt="Retina Background" className="video-background" />
                {/* Control buttons */}
                <div className="control-buttons">
                    <div 
                        className="
                        -positions-btn" 
                        onClick={
                            Positions}
                    >
                        Shuffle
                    </div>
                </div>
                
                {/* Content container */}
                <div className="content-container">
                    <div className="retina-container" ref={containerRef}>
                        {data.map((product) => (
                            <Draggable
                                key={product.id}
                                position={positions[product.id] || { x: 0, y: 0 }}
                                onStart={(e) => onStart(e, product.id)}
                                onStop={(e, data) => onStop(e, product.id, { x: data.x, y: data.y })}
                                bounds="parent"
                                defaultClassName="draggable-item"
                                defaultClassNameDragging="dragging"
                                defaultClassNameDragged="dragged"
                            >
                                <div 
                                    role='button' 
                                    className="draggable-product"  
                                    style={{ 
                                        zIndex: zIndices[product.id] || 1,
                                        cursor: 'move'
                                    }} 
                                    tabIndex={0}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            navigate(`/productDetails/${product.id}`);
                                        }
                                    }}
                                >
                                    <img
                                        src={product.imgUrl?.[0] || product.imgUrl}
                                        alt={product.productName || 'NFT Product'}
                                        width="240"
                                        height="240"
                                        className="retina_product-image"
                                        draggable="false"
                                    />
                                </div>
                            </Draggable>
                        ))}
                    </div>
                </div>
            </section>
        </Helmet>
    );
}

export default Retina;